function getCommonEvaluationsItems(proposal) {
  return [
    {
      title: 'Safety',
      comment: proposal.experiment_color?.safety_evaluation?.comments_review ?? '-',
      evaluation: proposal.experiment_color?.safety_evaluation?.color ?? '-',
    },
    {
      title: 'Radiation',
      comment: proposal.experiment_color?.radiation_evaluation?.comments_review ?? '-',
      evaluation: proposal.experiment_color?.radiation_evaluation?.color ?? '-',
    },
    {
      title: 'Technical comment',
      comment: proposal.technical_evaluation?.comments ?? '-',
      evaluation: proposal.technical_evaluation?.feasibility
        ? proposal.technical_evaluation.feasibility.replaceAll('_', ' ')
        : '-',
    },
  ];
}

function getCommentsForUserItems(proposal) {
  return [
    {
      title: 'Safety comment for user',
      comment: proposal.evaluations_data?.safety_evaluation_comments ?? '-',
    },
    {
      title: 'Radiation comment for user',
      comment: proposal.evaluations_data?.radiation_evaluation_comments ?? '-',
    },
    {
      title: 'Technical comment for user',
      comment: proposal.technical_evaluation?.comments_for_user ?? '-',
    },
  ];
}

function getFinalGradeItem(proposal) {
  return {
    title: 'Scientific merit',
    comment: proposal.final_grade?.comments ?? '-',
    evaluation: proposal.final_grade?.acceptance_mark ?? '-',
  };
}

function getManagementEvaluationItem(proposal) {
  return {
    title: 'Management evaluation',
    comment: proposal.management_evaluation?.comments ?? '-',
    evaluation: proposal.management_evaluation?.acceptance_mark ?? '-',
  };
}

function getExperimentColorItem(proposal) {
  return {
    title: 'Experiment color',
    color: proposal.experiment_color?.evaluated_color ?? '-',
  };
}

export {
  getCommonEvaluationsItems,
  getCommentsForUserItems,
  getFinalGradeItem,
  getManagementEvaluationItem,
  getExperimentColorItem,
};
